import { AxiosResponse } from "axios"
import SecureClient from "../SecureClient"
import { BaseWorkflowTaskModel, WorkflowTaskQueueSnapshot, WorkflowTaskState } from "./DTOs"

export default class WorkflowTaskQueueClient extends SecureClient {

	public getAnonymousQueue = (workflowTaskState?: WorkflowTaskState): Promise<AxiosResponse<BaseWorkflowTaskModel[]>> => {
		return this._api.get<BaseWorkflowTaskModel[]>(`WorkflowTaskQueue/AnonymousQueue`, {
			headers: {
				...this.acceptHeader,
				...this.contentTypeHeader
			},
			params: {
				workflowTaskState: workflowTaskState
			}
		})
	}
	
	/**
		 * Get the next workflow task in the queue belonging to the id (user or group)
		 * @param id the id of the user or group to get the next workflow task for
		 * @returns the id of the next workflow task
		 */
	public getNextInQueue = (id: number): Promise<AxiosResponse<number>> => {
		return this._api.get<number>(`WorkflowTaskQueue/${id}/Next`, {
			headers: {
				...this.acceptHeader,
				...this.contentTypeHeader
			}
		})
	}

	/**
	 * Get a workflow task queue
	 * @param queueId the id of the user or group the queue belongs to
	 * @param workflowTaskState optional - unlocked, locked, active, done, or all
	 * @returns the workflow tasks belonging to the specified user or group
	 */
	public getQueue = (queueId: number, workflowTaskState?: WorkflowTaskState): Promise<AxiosResponse<BaseWorkflowTaskModel[]>> => {
		return this._api.get<BaseWorkflowTaskModel[]>(`WorkflowTaskQueue/${queueId}`, {
			headers: {
				...this.acceptHeader,
				...this.contentTypeHeader
			},
			params: {
				workflowTaskState: workflowTaskState
			}
		})
	}

	/**
	 * Get the information of queues belonging to a user that the workflow task queue dashboard needs
	 * @param userId 
	 * @returns the assignment type, assigned to, and item count of queues belonging to the user 
	 * (assigned to them or groups they belong to)
	 */
	public getQueueSnapshots = (userId: number): Promise<AxiosResponse<WorkflowTaskQueueSnapshot[]>> => {
		return this._api.get<WorkflowTaskQueueSnapshot[]>(`WorkflowTaskQueue/${userId}/Snapshots`, {
			headers: {
				...this.acceptHeader,
				...this.contentTypeHeader
			}
		})
	}
}